@if (view() === 'details') {
  <h2 mat-dialog-title>{{ meeting.title }}</h2>
  <mat-dialog-content>
    <div class="details-grid">
      <span class="detail-label">Student</span>
      <span class="detail-value"
        >{{ meeting.studentName }} &bull; Grade {{ meeting.gradeLevel }}</span
      >

      <span class="detail-label">Date &amp; Time</span>
      <span class="detail-value">
        {{ meeting.start | date: 'EEEE, MMMM d' }} &bull; {{ meeting.start | date: 'h:mm' }}–{{
          meeting.end | date: 'h:mm a'
        }}
      </span>

      <span class="detail-label">Status</span>
      <span class="detail-value">
        <span class="status" [class]="meeting.state">{{ meeting.stateLabel }}</span>
      </span>

      @if (meeting.meetingType === 'in-person') {
        <span class="detail-label">Location</span>
        <span class="detail-value">{{ meeting.location || 'TBD' }}</span>
      } @else {
        <span class="detail-label">Meeting Link</span>
        <span class="detail-value">
          @if (meeting.isOver) {
            Online
          } @else if (meeting.meetingLink && meeting.meetingLink !== 'Link pending') {
            <a
              data-testid="meeting-link"
              [href]="meeting.meetingLink"
              target="_blank"
              rel="noopener"
              >{{ meeting.meetingLink }}</a
            >
          } @else {
            Link pending
          }
        </span>
      }

      <span class="detail-label">Details</span>
      <span class="detail-value reason-text">{{
        meeting.description || 'No additional details provided.'
      }}</span>

      @if (meeting.note) {
        <span class="detail-label">Notes</span>
        <span class="detail-value reason-text note-row">
          <span class="note-preview" data-testid="counselor-note"
            >{{ notePreview }}{{ notePreviewTruncated ? '…' : '' }}</span
          >
          <button
            mat-button
            class="view-note-link"
            type="button"
            data-testid="view-note-btn"
            (click)="goToView('note')"
          >
            View note
          </button>
        </span>
      }

      @if (meeting.isChangeRequest) {
        <span class="detail-label">Proposed changes</span>
        <span class="detail-value">
          {{ meeting.proposedStart | date: 'EEEE, MMMM d' }} &bull;
          {{ meeting.proposedStart | date: 'h:mm' }}–{{ meeting.proposedEnd | date: 'h:mm a' }}
          <span class="status pending" data-testid="proposal-pending-chip">Pending response</span>
          @if (meeting.proposedMessage) {
            <br />
            <span class="reason-text">{{ meeting.proposedMessage }}</span>
          }
        </span>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button data-testid="close-details-btn" mat-button type="button" (click)="dialogRef.close()">
      Close
    </button>
    @if (meeting.status !== 'canceled' && meeting.status !== 'declined') {
      <button
        data-testid="add-note-btn"
        mat-flat-button
        class="add-note-btn-blue"
        type="button"
        (click)="openAddNote()"
      >
        {{ meeting.note ? 'Edit note' : 'Add notes' }}
      </button>
    }
    @if (meeting.isActive) {
      <button
        data-testid="propose-changes-btn"
        mat-flat-button
        class="add-note-btn-blue"
        type="button"
        (click)="proposeChanges()"
      >
        Propose changes
      </button>
      <button
        data-testid="cancel-meeting-btn"
        mat-flat-button
        class="cancel-btn-red"
        type="button"
        (click)="goToView('cancel')"
      >
        Cancel meeting
      </button>
    }
  </mat-dialog-actions>
}

@if (view() === 'cancel') {
  <h2 mat-dialog-title>Cancel this meeting?</h2>
  <mat-dialog-content>
    <p class="cancel-message">
      Are you sure you want to cancel the <strong>{{ meeting.title }}</strong> meeting with
      <strong>{{ meeting.studentName }}</strong> on
      <strong>{{ meeting.start | date: 'EEEE, MMMM d' }}</strong
      >?
    </p>
    <p class="cancel-note">The student will be notified that this meeting was canceled.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button data-testid="keep-meeting-btn" mat-button type="button" (click)="goToView('details')">
      Keep meeting
    </button>
    <button
      data-testid="confirm-cancel-btn"
      mat-flat-button
      color="warn"
      type="button"
      [disabled]="submitting()"
      (click)="submitCancel()"
    >
      {{ submitting() ? 'Cancelling…' : 'Yes, cancel' }}
    </button>
  </mat-dialog-actions>
}

@if (view() === 'canceled') {
  <h2 mat-dialog-title>Meeting canceled</h2>
  <mat-dialog-content>
    <p class="cancel-message">
      The <strong>{{ meeting.title }}</strong> meeting with
      <strong>{{ meeting.studentName }}</strong> on
      <strong>{{ meeting.start | date: 'EEEE, MMMM d' }}</strong> has been canceled.
    </p>
    <p class="cancel-note">The student has been notified.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      data-testid="cancel-done-btn"
      mat-flat-button
      color="primary"
      type="button"
      (click)="finishCancel()"
    >
      Done
    </button>
  </mat-dialog-actions>
}

@if (view() === 'note') {
  <h2 mat-dialog-title>Notes</h2>
  <mat-dialog-content>
    <p class="note-full-text" data-testid="note-full-text">{{ meeting.note }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button data-testid="note-back-btn" mat-button type="button" (click)="goToView('details')">
      Back
    </button>
  </mat-dialog-actions>
}

@if (view() === 'addNote') {
  <h2 mat-dialog-title>Meeting notes</h2>
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="note-field" subscriptSizing="dynamic">
      <textarea
        matInput
        rows="8"
        [maxlength]="maxNoteLength"
        placeholder="Notes about this meeting — visible to the student too"
        [ngModel]="noteDraft()"
        (ngModelChange)="noteDraft.set($event)"
        data-testid="note-input"
      ></textarea>
      <mat-hint align="end">{{ noteDraft().length }}/{{ maxNoteLength }}</mat-hint>
    </mat-form-field>
  </mat-dialog-content>
  @if (noteError()) {
    <p class="submit-error" data-testid="note-error">{{ noteError() }}</p>
  }
  <mat-dialog-actions align="end">
    <button data-testid="cancel-note-btn" mat-button type="button" (click)="goToView('details')">
      Cancel
    </button>
    <button
      data-testid="save-note-btn"
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="savingNote()"
      (click)="saveNote()"
    >
      {{ savingNote() ? 'Saving…' : 'Save note' }}
    </button>
  </mat-dialog-actions>
}
